// Cari Barang global (Gudang Rido): Offline + Shopee + Tokopedia sekaligus. Memakai pencarian & scan yang sudah ada; baca-saja.
import { useEffect, useState } from "react";
import { Search, ScanLine, X } from "lucide-react";
import { OrderTrackResults } from "./order_track";
import ScanMockupModal from "./scan_mockup";

export function GlobalFind({ operator, onClose }) {
  const [text, setText] = useState("");
  const [q, setQ] = useState("");
  const [scan, setScan] = useState(false);
  useEffect(() => { const t = setTimeout(() => setQ(text.trim()), 300); return () => clearTimeout(t); }, [text]);
  return <section className="gfind" data-testid="rido-global-find">
    <div className="gfind-bar">
      <label className="gfind-input"><Search size={18} aria-hidden="true"/>
        <input autoFocus value={text} onChange={e => setText(e.target.value)} placeholder="Nomor pesanan / barcode, pelanggan, produk, atau desainer…"
          aria-label="Cari barang di semua pesanan" data-testid="rido-global-find-input"/>
        {text && <button type="button" onClick={() => setText("")} aria-label="Hapus" data-testid="rido-global-find-clear"><X size={16}/></button>}
      </label>
      <button type="button" className="gfind-btn gfind-scan" onClick={() => setScan(true)} data-testid="rido-global-find-scan"><ScanLine size={18}/> Scan Cari Barang</button>
      <button type="button" className="gfind-btn gfind-close" onClick={onClose} data-testid="rido-global-find-close">Tutup</button>
    </div>
    {q.length >= 3 ? <OrderTrackResults q={q} source="all" withMockup/> : <div className="monitor-v2-empty" data-testid="rido-global-find-empty">Ketik minimal 3 karakter atau scan barcode — termasuk pesanan yang sudah selesai atau dikirim.</div>}
    {scan && <ScanMockupModal open onClose={() => setScan(false)} operator={operator} searchOnly onOpenOrder={(code) => { setScan(false); setText(String(code || "")); }}/>}
  </section>;
}

export function GlobalFindButton({ open, onClick }) {
  return <button type="button" className={`gfind-top ${open ? "active" : ""}`} onClick={onClick} aria-pressed={open} data-testid="rido-global-find-btn">
    <Search size={18} aria-hidden="true"/> <span className="gfind-title">{open ? "Tutup Cari Barang" : "Cari Barang"}</span>
    <small>Offline · Shopee · Tokopedia — ketik atau scan barcode</small>
  </button>;
}
